import axios from 'axios';
import {useAuthStore} from '@/stores/authStore.js';
import {checkToken} from "@/utils/lambdaUtils.js";
import {ACCEPTED_FILE_TYPES} from "@/utils/constants.js";

const baseUrl = import.meta.env.VITE_APP_API_BASE_URL + "/s3";

export const uploadFile = async (file, fileName) => {
    await checkToken();
    const authStore = useAuthStore();

    const isValidFile = await validateFile(file);
    if (!isValidFile) {
        file.type = ''; //make it fail on submission to service below if not a file we're expecting
    }
    const payload = {
        fileName: fileName,
        fileType: file.type
    };
    console.log("lambda.execute api url: " + baseUrl + "/getSignedUrl");
    return axios.post(baseUrl + "/getSignedUrl", payload, {
        headers: {
            'Authorization': `Bearer ${authStore.token}`,  // Include token in the header
            'Content-Type': 'application/json'  // Set content type
        }
    })
        .then((res) => {
            console.log("execute signedurl");
            return Promise.resolve(res.data || '/');
        })
        .catch((err) => {
            console.log("Error: ", err.response ? err.response.data : err.message);
            return Promise.reject('/');
        });
};

export const getPreSignedUrl = async (file) => {
    let isValidFile = await validateFileType(file);
    if (!isValidFile) {
        throw new Error('Unsupported file type, please try another.');
    }
    isValidFile = await validateFileSize(file);
    if (!isValidFile) {
        throw new Error('Unsupported file size, must be less than 250mb.');
    }

    const payload = {
        fileName: file.name,
        fileType: file.type
    };

    const headers = {
        headers: {
            'Content-Type': 'application/json'  // Set content type
        }
    };

    // Get the pre-signed URL from the server
    try {
        const response= await axios.post( baseUrl + "/getSignedUrl", payload, headers);
        if (response.data && response.data) {
            return response.data;
        } else {
            throw new Error("Unable to get signed upload URL. Please try again later.");
        }
    } catch (error) {
        throw new Error (error.message);
    }
};

export const validateFileType = async (file) => {
    const allowedTypes = new Set(Object.values(ACCEPTED_FILE_TYPES));
    return file?.type && allowedTypes.has(file.type.toLowerCase());
};

export const validateFileSize = async (file) => {
    return file.size / 1024 / 1024 <= 250;
};
